export default __webpack_public_path__ + "be810be3a3e14c682a257d6eff341fe4.woff2";